// @ts-nocheck
import * as React from "react";
import { Ic } from "../screens/common";
import { useEscapeKey } from "./useEscapeKey";
import { getRecentReasons } from "./recentReasons";

// Reason capture for declining a match recommendation. The reason becomes
// the audit log meta for match_rejected, so operators can audit *why* a
// candidate was passed over later. The body intentionally avoids loading
// extra state — the parent owns the API call so multiple call sites can
// reuse this with different downstream behavior.
const REASON_HISTORY_KEY = "match_reject";

// 자주 쓰이는 거절 사유 — 칩 클릭으로 textarea에 채워 넣어 입력 부담을
// 줄인다. 운영팀이 실제로 사용하는 표현으로 다듬어가며 길어지면 settings
// 로 옮길 수 있도록 한 상수에 모아둔다.
const REASON_TEMPLATES = [
  "거리가 멀어 응급 대응 어려움",
  "보호자 선호 매니저와 불일치",
  "이전 방문 만족도 낮음",
  "매니저 부하 한계 초과",
  "동일 기관 매니저 다수 보유",
  "자격 / 전문성 불일치",
];

export function RejectMatchModal({ match, onClose, onConfirm, busy = false, err = null }) {
  useEscapeKey(onClose);
  const [note, setNote] = React.useState("");
  const noteRef = React.useRef(null);
  // Lazy-init: only read localStorage once when the modal first mounts.
  const [recent] = React.useState(() => getRecentReasons(REASON_HISTORY_KEY));

  React.useEffect(() => {
    // Autofocus the textarea so a fast operator can just type-then-Enter.
    noteRef.current?.focus();
  }, []);

  const submit = (e) => {
    if (e) e.preventDefault();
    if (busy) return;
    onConfirm({ note: note.trim() });
  };

  const cm = match.care_manager;

  return (
    <div onClick={onClose}
      style={{position:'fixed', inset:0, background:'rgba(20,16,12,0.4)', display:'grid', placeItems:'center', zIndex:50}}>
      <form onSubmit={submit} onClick={e=>e.stopPropagation()} className="card" style={{width:480, padding:0}}>
        <div style={{padding:'16px 22px', borderBottom:'1px solid var(--border-soft)', display:'flex', alignItems:'center', justifyContent:'space-between'}}>
          <div>
            <div className="h3">매칭 거절</div>
            <div className="muted" style={{fontSize:11, marginTop:2}}>
              {cm.name} · {cm.qualification} · 매칭 점수 {match.score}
            </div>
          </div>
          <button type="button" className="btn btn-ghost btn-sm" onClick={onClose}>{Ic.close}</button>
        </div>

        {err && (
          <div style={{margin:'14px 22px 0', padding:'10px 14px', background:'var(--rose-50)', color:'var(--rose-500)', borderRadius:10, fontSize:12.5}}>
            {err}
          </div>
        )}

        <div style={{padding:22, display:'grid', gap:10}}>
          <div className="label">사유 <span className="muted" style={{fontWeight:400, fontSize:10.5}}>(감사 로그에 기록됩니다)</span></div>

          <div>
            <div className="muted" style={{fontSize:10.5, fontWeight:700, letterSpacing:'0.04em', marginBottom:6}}>
              자주 쓰는 사유
            </div>
            <div style={{display:'flex', flexWrap:'wrap', gap:6}}>
              {REASON_TEMPLATES.map((r) => (
                <button key={r} type="button"
                  onClick={()=>setNote(r)}
                  title={r}
                  style={{
                    padding:'4px 10px', fontSize:11, fontWeight:600,
                    background: note === r ? 'var(--orange-50)' : 'var(--surface)',
                    color: note === r ? 'var(--orange-700)' : 'var(--ink-2)',
                    border: '1px solid ' + (note === r ? 'var(--orange-500)' : 'var(--border-soft)'),
                    borderRadius: 99, cursor: 'pointer',
                  }}>
                  {r}
                </button>
              ))}
            </div>
          </div>

          <textarea
            ref={noteRef}
            className="input"
            rows={4}
            value={note}
            onChange={e=>setNote(e.target.value)}
            placeholder="템플릿을 선택하거나 직접 입력하세요"
            style={{resize:'vertical', minHeight:90}}
          />
          {recent.length > 0 && (
            <div>
              <div className="muted" style={{fontSize:10.5, fontWeight:700, letterSpacing:'0.04em', marginBottom:6}}>
                최근 내가 쓴 사유
              </div>
              <div style={{display:'flex', flexWrap:'wrap', gap:6}}>
                {recent.map((r) => (
                  <button key={r} type="button"
                    onClick={()=>setNote(r)}
                    title={r}
                    style={{
                      padding:'4px 10px', fontSize:11, fontWeight:600,
                      background:'var(--bg-sub)', color:'var(--ink-2)',
                      border:'1px solid var(--border-soft)', borderRadius:99,
                      cursor:'pointer', maxWidth:240, overflow:'hidden',
                      textOverflow:'ellipsis', whiteSpace:'nowrap',
                    }}>
                    {r}
                  </button>
                ))}
              </div>
            </div>
          )}
          <div className="muted" style={{fontSize:11}}>
            거절된 매칭은 인박스에서 회색으로 표시되며, 케이스는 계속 다른 후보가 있다면 보류됩니다.
          </div>
        </div>

        <div style={{padding:'14px 22px', borderTop:'1px solid var(--border-soft)', display:'flex', justifyContent:'flex-end', gap:8}}>
          <button type="button" className="btn btn-ghost btn-md" onClick={onClose}>취소</button>
          <button type="submit" className="btn btn-primary btn-md" disabled={busy}
            style={{background:'var(--rose-500)'}}>
            {busy ? '처리 중…' : '거절 확정'}
          </button>
        </div>
      </form>
    </div>
  );
}
